import { FormEvent, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { DocumentationContentFormat } from '../../services/documentationApi';

type DocumentationCreatePageModalProps = {
  open: boolean;
  onClose: () => void;
  onConfirm: (contentFormat: DocumentationContentFormat) => void;
};

export function DocumentationCreatePageModal({
  open,
  onClose,
  onConfirm,
}: DocumentationCreatePageModalProps) {
  const [contentFormat, setContentFormat] = useState<DocumentationContentFormat>('Html');

  useEffect(() => {
    if (open) setContentFormat('Html');
  }, [open]);

  if (!open) return null;

  function handleSubmit(event: FormEvent): void {
    event.preventDefault();
    onConfirm(contentFormat);
  }

  return createPortal(
    <div className="docs-modal-backdrop" role="presentation" onClick={onClose}>
      <div
        className="docs-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="docs-create-page-title"
        onClick={(e) => e.stopPropagation()}
      >
        <h3 id="docs-create-page-title" className="docs-modal__title">
          Nova página
        </h3>
        <form onSubmit={handleSubmit} className="erp-form">
          <fieldset className="space-y-3">
            <legend className="erp-label mb-2">Formato do conteúdo</legend>
            <label className="flex cursor-pointer items-start gap-3 rounded-lg border border-secondary-200 p-3 has-[:checked]:border-primary-500 has-[:checked]:bg-primary-50">
              <input
                type="radio"
                name="contentFormat"
                className="mt-1"
                checked={contentFormat === 'Html'}
                onChange={() => setContentFormat('Html')}
              />
              <span>
                <span className="block font-medium text-secondary-900">HTML (editor rico)</span>
                <span className="mt-0.5 block text-xs text-secondary-500">
                  Formatação visual com tabela, callouts, imagens e vídeo.
                </span>
              </span>
            </label>
            <label className="flex cursor-pointer items-start gap-3 rounded-lg border border-secondary-200 p-3 has-[:checked]:border-primary-500 has-[:checked]:bg-primary-50">
              <input
                type="radio"
                name="contentFormat"
                className="mt-1"
                checked={contentFormat === 'Markdown'}
                onChange={() => setContentFormat('Markdown')}
              />
              <span>
                <span className="block font-medium text-secondary-900">Markdown</span>
                <span className="mt-0.5 block text-xs text-secondary-500">
                  Texto técnico com títulos, listas e código. O formato não poderá ser trocado depois.
                </span>
              </span>
            </label>
          </fieldset>
          <div className="mt-4 flex justify-end gap-2">
            <button type="button" className="erp-btn-secondary" onClick={onClose}>
              Cancelar
            </button>
            <button type="submit" className="erp-btn-primary">
              Criar página
            </button>
          </div>
        </form>
      </div>
    </div>,
    document.body,
  );
}
